export const news = [
  {
    id: 'annual-hanfu-drama-summer-slate',
    title: '年度古装大剧定档暑期，主创阵容首度公开',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photography%20of%20an%20elegant%20traditional%20Chinese%20hanfu%20costume%20on%20a%20mannequin%20in%20a%20bright%20minimalist%20studio%20with%20warm%20cream%20background%20and%20soft%20natural%20lighting%2C%20high%20detail%2C%20clean%20harmonious%20composition&width=800&height=450&seq=news-ent-01&orientation=landscape',
    summary:
      '多部古装新作宣布定档暑期档，片方同步公开导演与主演阵容，服化道与取景地成为讨论焦点。',
    publishedAt: '2026-10-14 09:20',
    author: '吃瓜网娱乐组',
    categoryId: 'entertainment',
    tags: ['古装剧', '暑期档', '影视'],
    views: 186420,
    content: [
      {
        type: 'paragraph',
        text: '随着暑期档临近，多部备受关注的古装题材作品陆续宣布定档。片方在发布会上首次完整公开了导演团队与主演阵容，并播放了时长两分钟的先导片花。',
      },
      {
        type: 'paragraph',
        text: '从公开的物料来看，新作在服化道与场景搭建上投入不小。剧组介绍，为还原剧中主要场景，美术团队参考了大量文献资料，并在影视基地搭建了可长期使用的实景街区。',
      },
      {
        type: 'image',
        src: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20photo%20of%20a%20traditional%20Chinese%20film%20set%20with%20wooden%20pavilions%2C%20soft%20golden%20hour%20light%2C%20warm%20neutral%20tones%2C%20editorial%20documentary%20style%2C%20high%20detail%20and%20clean%20composition&width=1000&height=560&seq=news-ent-01-body&orientation=landscape',
        caption: '剧组公开的实景街区搭建现场（资料图）',
      },
      {
        type: 'paragraph',
        text: '业内人士分析，古装剧仍是暑期档的重要组成部分，观众对制作水准与叙事节奏的要求逐年提高，能否在开播后保持口碑，将直接影响后续的排播与招商。',
      },
      {
        type: 'paragraph',
        text: '目前多部作品已进入宣传期，主创团队将陆续参与线上直播与线下路演，与观众分享创作幕后。',
      },
    ],
  },
  {
    id: 'lin-wan-concert-extra-show',
    title: '林晚演唱会官宣加场，预约量创下新高',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20concert%20stage%20photo%20with%20warm%20orange%20spotlights%20and%20a%20large%20empty%20arena%2C%20clean%20modern%20production%20design%2C%20soft%20haze%2C%20high%20detail%2C%20harmonious%20warm%20color%20palette&width=800&height=450&seq=news-cele-01&orientation=landscape',
    summary:
      '因预约人数超出预期，歌手林晚宣布在原定场次基础上加开两场，并同步公布新的售票安排。',
    publishedAt: '2026-10-14 08:05',
    author: '吃瓜网娱乐组',
    categoryId: 'celebrity',
    tags: ['林晚', '演唱会', '演出'],
    views: 243980,
    content: [
      {
        type: 'paragraph',
        text: '歌手林晚的巡演主办方发布公告称，由于前期预约人数大幅超过场馆容量，将在此前公布的城市各加开两场演出，力求让更多观众能够进场。',
      },
      {
        type: 'paragraph',
        text: '公告同时说明了加场的售票节奏与实名入场规则。主办方提醒观众通过官方渠道购票，避免因非正规渠道产生纠纷。',
      },
      {
        type: 'image',
        src: 'https://readdy.ai/api/search-image?query=Close%20up%20editorial%20shot%20of%20a%20stage%20microphone%20stand%20and%20guitar%20under%20soft%20warm%20stage%20lights%2C%20minimal%20background%2C%20warm%20neutral%20tones%2C%20high%20detail%2C%20clean%20composition&width=1000&height=560&seq=news-cele-01-body&orientation=landscape',
        caption: '巡演舞台彩排现场（资料图）',
      },
      {
        type: 'paragraph',
        text: '林晚在个人社交账号上回应，感谢歌迷的等待，并表示会为新一轮演出重新设计部分环节，带来与首轮不同的观演体验。',
      },
      {
        type: 'paragraph',
        text: '演出行业从业者表示，今年线下演出市场持续回暖，观众对现场体验的期待也在提升，主办方在票务与秩序管理上的投入明显增加。',
      },
    ],
  },
  {
    id: 'city-walk-trend-young-people',
    title: '“城市漫步”玩法走红，年轻人重新发现身边风景',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20young%20people%20walking%20along%20a%20quiet%20tree%20lined%20city%20street%20in%20warm%20afternoon%20light%2C%20clean%20minimal%20aesthetic%2C%20soft%20tones%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=450&seq=news-buzz-01&orientation=landscape',
    summary:
      '不赶行程、只沿街观察，越来越多年轻人用“城市漫步”的方式度过周末，也带动了街边小店的人气。',
    publishedAt: '2026-10-14 07:40',
    author: '吃瓜网热议组',
    categoryId: 'buzz',
    tags: ['城市漫步', '生活方式', '热点话题'],
    views: 152340,
    content: [
      {
        type: 'paragraph',
        text: '不需要机票，也不必做复杂攻略，选定一条路线慢慢走、随手拍，这种被称为“城市漫步”的休闲方式在社交平台上持续升温。',
      },
      {
        type: 'paragraph',
        text: '有参与者表示，漫步的重点不是打卡景点，而是重新观察那些日常被忽略的街道、老建筑与街边小店，节奏慢下来之后，反而更容易获得放松感。',
      },
      {
        type: 'image',
        src: 'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20small%20cozy%20neighborhood%20cafe%20storefront%20with%20plants%20and%20warm%20light%2C%20clean%20minimal%20style%2C%20soft%20warm%20tones%2C%20high%20detail%2C%20harmonious%20composition&width=1000&height=560&seq=news-buzz-01-body&orientation=landscape',
        caption: '街边小店因漫步人群的到来而更有人气（资料图）',
      },
      {
        type: 'paragraph',
        text: '不少商家也开始配合这一趋势，推出适合步行路线的休息点与轻食套餐，希望借助新的人流获得更多关注。',
      },
      {
        type: 'paragraph',
        text: '城市研究者认为，漫步的流行反映出人们对生活节奏的重新思考，也为街区活力与公共空间的利用提供了新的视角。',
      },
    ],
  },
  {
    id: 'community-canteen-upgrade',
    title: '多地推动社区食堂升级，老年助餐服务更便捷',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20bright%20clean%20community%20dining%20hall%20with%20wooden%20tables%20and%20simple%20warm%20decor%2C%20soft%20natural%20light%2C%20minimal%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=450&seq=news-soc-01&orientation=landscape',
    summary:
      '多个城市对社区食堂进行改造升级，增加适老化设施与配送服务，让老年居民在家门口就能吃上热饭。',
    publishedAt: '2026-10-13 19:15',
    author: '吃瓜网社会组',
    categoryId: 'society',
    tags: ['社区食堂', '民生', '助餐'],
    views: 98450,
    content: [
      {
        type: 'paragraph',
        text: '近期，多个城市陆续完成社区食堂的改造升级，除了改善就餐环境，还针对老年居民增加了低位取餐台、无障碍通道等适老化设施。',
      },
      {
        type: 'paragraph',
        text: '部分食堂还推出了预约订餐与上门配送服务，行动不便的居民可以通过电话或社区工作人员协助下单。',
      },
      {
        type: 'image',
        src: 'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20warm%20home%20style%20meals%20neatly%20served%20on%20a%20tray%20in%20a%20clean%20canteen%2C%20soft%20natural%20light%2C%20warm%20neutral%20tones%2C%20minimal%20aesthetic%2C%20high%20detail&width=1000&height=560&seq=news-soc-01-body&orientation=landscape',
        caption: '社区食堂提供的营养套餐（资料图）',
      },
      {
        type: 'paragraph',
        text: '社区工作人员介绍，食堂在菜品上尽量兼顾口味与营养，并根据季节调整菜单，同时为有特殊需求的居民提供定制选项。',
      },
      {
        type: 'paragraph',
        text: '有关方面表示，后续将继续完善助餐服务网络，让更多居民就近享受到方便、实惠的就餐服务。',
      },
    ],
  },
  {
    id: 'music-festival-return-offline',
    title: '音乐节回归线下，独立乐队迎来演出旺季',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20outdoor%20music%20festival%20crowd%20silhouettes%20in%20front%20of%20a%20warmly%20lit%20stage%20at%20dusk%2C%20soft%20orange%20and%20neutral%20tones%2C%20minimal%20modern%20aesthetic%2C%20high%20detail&width=800&height=450&seq=news-ent-02&orientation=landscape',
    summary:
      '随着线下活动恢复，各地音乐节密集举办，独立乐队获得更多登台机会，也带动周边文旅消费。',
    publishedAt: '2026-10-13 16:30',
    author: '吃瓜网娱乐组',
    categoryId: 'entertainment',
    tags: ['音乐节', '独立音乐', '演出市场'],
    views: 131200,
    content: [
      {
        type: 'paragraph',
        text: '入秋以来，各地音乐节排期明显加密，从城市公园到郊野草坪，不同规模的活动轮番登场，为乐迷提供了丰富的选择。',
      },
      {
        type: 'paragraph',
        text: '对于独立乐队而言，音乐节是重要的曝光渠道。多支乐队表示，线下演出恢复后，接到了比以往更多的邀约，巡演计划也随之增加。',
      },
      {
        type: 'image',
        src: 'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20band%20rehearsing%20in%20a%20warm%20lit%20studio%20with%20instruments%2C%20soft%20neutral%20tones%2C%20minimal%20aesthetic%2C%20high%20detail%2C%20clean%20composition&width=1000&height=560&seq=news-ent-02-body&orientation=landscape',
        caption: '乐队在排练室为音乐节做准备（资料图）',
      },
      {
        type: 'paragraph',
        text: '音乐节也带动了举办地周边的餐饮、住宿与交通消费，不少城市将音乐演出与本地文旅资源结合，推出配套活动。',
      },
      {
        type: 'paragraph',
        text: '业内人士提醒，观众在参与大型户外活动时应注意天气变化与现场秩序，提前规划出行路线。',
      },
    ],
  },
  {
    id: 'su-chen-new-album-return',
    title: '苏辰携新专辑回归，分享创作幕后故事',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20warm%20recording%20studio%20with%20a%20microphone%20and%20headphones%20on%20a%20desk%2C%20soft%20amber%20lighting%2C%20minimal%20clean%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=450&seq=news-cele-02&orientation=landscape',
    summary:
      '时隔两年，歌手苏辰发布全新专辑，接受采访时聊到创作灵感、录音过程以及此次尝试的新风格。',
    publishedAt: '2026-10-13 14:10',
    author: '吃瓜网娱乐组',
    categoryId: 'celebrity',
    tags: ['苏辰', '新专辑', '音乐'],
    views: 176500,
    content: [
      {
        type: 'paragraph',
        text: '歌手苏辰带着全新专辑回归，这张收录了十首作品的新专辑，被他自己形容为“一次重新认识自己的旅程”。',
      },
      {
        type: 'paragraph',
        text: '据介绍，专辑筹备历时近两年，期间他与制作团队反复打磨编曲，并首次尝试了此前较少涉猎的音乐风格。',
      },
      {
        type: 'image',
        src: 'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20vintage%20audio%20equipment%20and%20keyboard%20in%20a%20warm%20recording%20room%2C%20soft%20neutral%20tones%2C%20minimal%20aesthetic%2C%20high%20detail%2C%20clean%20composition&width=1000&height=560&seq=news-cele-02-body&orientation=landscape',
        caption: '专辑录制期间使用的设备（资料图）',
      },
      {
        type: 'paragraph',
        text: '在采访中，苏辰谈到创作中最看重“真诚”二字，希望听众能在歌曲里找到共鸣，而不仅仅是记住旋律。',
      },
      {
        type: 'paragraph',
        text: '新专辑上线后，相关话题持续占据讨论榜前列，他也透露后续将安排小规模现场演出，与听众近距离交流。',
      },
    ],
  },
  {
    id: 'culture-street-renewal-open',
    title: '文旅街区焕新开放，老建筑变身市民休闲空间',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20renovated%20historic%20brick%20street%20with%20warm%20string%20lights%20at%20evening%2C%20clean%20minimal%20aesthetic%2C%20soft%20warm%20tones%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=450&seq=news-soc-02&orientation=landscape',
    summary:
      '经过一年多改造，一处历史街区重新开放，在保留老建筑风貌的同时引入书店、展览与休闲设施。',
    publishedAt: '2026-10-13 11:45',
    author: '吃瓜网社会组',
    categoryId: 'society',
    tags: ['文旅街区', '城市更新', '休闲'],
    views: 87120,
    content: [
      {
        type: 'paragraph',
        text: '经过一年多修缮改造，一处承载着城市记忆的历史街区重新向公众开放。改造在保留原有建筑风貌的基础上，对内部空间进行了功能更新。',
      },
      {
        type: 'paragraph',
        text: '如今街区里既有独立书店、小型展览空间，也有供人歇脚的庭院与咖啡座，成为市民日常休闲的新去处。',
      },
      {
        type: 'image',
        src: 'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20quiet%20courtyard%20garden%20inside%20a%20renovated%20old%20building%20with%20plants%20and%20warm%20light%2C%20minimal%20clean%20style%2C%20soft%20neutral%20tones%2C%20high%20detail&width=1000&height=560&seq=news-soc-02-body&orientation=landscape',
        caption: '改造后开放的庭院空间（资料图）',
      },
      {
        type: 'paragraph',
        text: '负责改造的团队表示，设计的核心是“让老建筑继续被使用”，因此在动线、照明与无障碍设施上做了细致考虑。',
      },
      {
        type: 'paragraph',
        text: '开放首周，街区迎来不少前来参观的市民，管理方也提醒大家错峰出行，文明参观。',
      },
    ],
  },
  {
    id: 'creative-craft-videos-trend',
    title: '创意手工视频走红，实用与趣味并存',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20flat%20lay%20photo%20of%20colorful%20handmade%20craft%20tools%20and%20materials%20on%20a%20light%20wooden%20table%2C%20clean%20minimal%20aesthetic%2C%20soft%20warm%20tones%2C%20high%20detail&width=800&height=450&seq=news-buzz-02&orientation=landscape',
    summary:
      '一批“动手做点东西”的创意视频在平台上受到欢迎，博主用日常材料做出实用小物，引发观众模仿。',
    publishedAt: '2026-10-13 09:50',
    author: '吃瓜网热议组',
    categoryId: 'buzz',
    tags: ['手工', '创意视频', '热门话题'],
    views: 119870,
    content: [
      {
        type: 'paragraph',
        text: '最近，一类主打“动手做点东西”的创意视频在平台上受到关注。博主们用常见的日常材料，制作出既实用又有趣的小物件。',
      },
      {
        type: 'paragraph',
        text: '与追求炫技不同，这类内容更强调过程的可见与结果的可用，不少观众表示看完之后会忍不住动手尝试。',
      },
      {
        type: 'image',
        src: 'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20hands%20assembling%20a%20small%20wooden%20craft%20on%20a%20bright%20workbench%2C%20soft%20natural%20light%2C%20minimal%20clean%20aesthetic%2C%20warm%20neutral%20tones%2C%20high%20detail&width=1000&height=560&seq=news-buzz-02-body&orientation=landscape',
        caption: '博主在拍摄手工制作过程（资料图）',
      },
      {
        type: 'paragraph',
        text: '有博主分享，走红的秘诀并不复杂，把步骤讲清楚、把细节拍明白，观众自然愿意停留和转发。',
      },
      {
        type: 'paragraph',
        text: '内容创作者分析，实用型创意内容容易形成口碑传播，也为品牌与平台提供了新的合作方向。',
      },
    ],
  },
  {
    id: 'animated-film-market-recovery',
    title: '动画电影市场回暖，亲子观影需求持续增长',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20bright%20cozy%20cinema%20auditorium%20with%20rows%20of%20warm%20seat%20lights%2C%20minimal%20clean%20aesthetic%2C%20soft%20neutral%20tones%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=450&seq=news-ent-03&orientation=landscape',
    summary:
      '多部动画电影陆续上映，影院亲子场次排片增加，家庭观众成为票房增长的重要力量。',
    publishedAt: '2026-10-12 20:30',
    author: '吃瓜网娱乐组',
    categoryId: 'entertainment',
    tags: ['动画电影', '亲子', '票房'],
    views: 103460,
    content: [
      {
        type: 'paragraph',
        text: '近期多部动画电影集中上映，涵盖奇幻冒险、温情成长等不同题材，影院也相应增加了亲子场次的排片。',
      },
      {
        type: 'paragraph',
        text: '影院工作人员观察，周末上午与傍晚是家庭观众较为集中的时段，不少观众会提前通过线上渠道选座。',
      },
      {
        type: 'image',
        src: 'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20popcorn%20and%20drink%20on%20a%20cinema%20seat%20armrest%20with%20warm%20screen%20glow%2C%20minimal%20clean%20aesthetic%2C%20soft%20neutral%20tones%2C%20high%20detail&width=1000&height=560&seq=news-ent-03-body&orientation=landscape',
        caption: '影院观影场景（资料图）',
      },
      {
        type: 'paragraph',
        text: '业内人士表示，动画作品的口碑传播往往依赖观众自发推荐，制作方在故事与画面上投入更多，也更看重映后评价。',
      },
      {
        type: 'paragraph',
        text: '随着年末档期临近，预计还将有更多动画新片与观众见面。',
      },
    ],
  },
  {
    id: 'chen-yu-charity-reading',
    title: '陈屿亮相公益活动，呼吁关注乡村儿童阅读',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20stacks%20of%20colorful%20children%20books%20on%20a%20light%20wooden%20shelf%20with%20warm%20soft%20light%2C%20minimal%20clean%20aesthetic%2C%20warm%20neutral%20tones%2C%20high%20detail&width=800&height=450&seq=news-cele-03&orientation=landscape',
    summary:
      '演员陈屿出席公益阅读活动，与志愿者一起整理图书，并呼吁更多人关注乡村儿童的阅读条件。',
    publishedAt: '2026-10-12 17:05',
    author: '吃瓜网娱乐组',
    categoryId: 'celebrity',
    tags: ['陈屿', '公益', '阅读'],
    views: 142760,
    content: [
      {
        type: 'paragraph',
        text: '演员陈屿近日出席一场公益阅读活动，与志愿者一同整理捐赠图书，并参与了一场面向儿童的朗读分享。',
      },
      {
        type: 'paragraph',
        text: '他在活动中表示，阅读能为孩子打开更大的世界，希望能有更多人参与到图书捐赠与阅读陪伴中来。',
      },
      {
        type: 'image',
        src: 'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20bright%20reading%20corner%20with%20a%20low%20wooden%20bookshelf%20and%20a%20soft%20cushion%2C%20minimal%20clean%20aesthetic%2C%20warm%20neutral%20tones%2C%20high%20detail&width=1000&height=560&seq=news-cele-03-body&orientation=landscape',
        caption: '活动现场布置的阅读角（资料图）',
      },
      {
        type: 'paragraph',
        text: '主办方介绍，此次募集到的图书将分批送往有需要的学校与社区图书角，后续还将组织定期的线上共读活动。',
      },
      {
        type: 'paragraph',
        text: '活动结束后，相关话题在社交平台上引发讨论，不少网友表示愿意以捐书或志愿服务的方式参与。',
      },
    ],
  },
  {
    id: 'city-greenway-cycling',
    title: '城市绿道串联公园，骑行通勤族有了新选择',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20clean%20tree%20lined%20greenway%20bike%20path%20curving%20through%20a%20park%2C%20soft%20morning%20light%2C%20minimal%20clean%20aesthetic%2C%20warm%20neutral%20tones%2C%20high%20detail&width=800&height=450&seq=news-soc-03&orientation=landscape',
    summary:
      '随着城市绿道网络不断完善，骑行通勤与周末休闲骑行的人明显增多，绿色出行成为更多人的日常选择。',
    publishedAt: '2026-10-12 13:25',
    author: '吃瓜网社会组',
    categoryId: 'society',
    tags: ['绿道', '骑行', '绿色出行'],
    views: 76320,
    content: [
      {
        type: 'paragraph',
        text: '随着城市绿道网络逐步串联起沿线公园与社区，越来越多的市民选择骑车通勤或周末骑行休闲。',
      },
      {
        type: 'paragraph',
        text: '骑行者表示，绿道沿途风景好、干扰少，既能锻炼身体，也让通勤过程变得更放松。',
      },
      {
        type: 'image',
        src: 'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20bicycle%20parked%20beside%20a%20scenic%20greenway%20with%20lush%20trees%20and%20soft%20light%2C%20minimal%20clean%20aesthetic%2C%20warm%20neutral%20tones%2C%20high%20detail&width=1000&height=560&seq=news-soc-03-body&orientation=landscape',
        caption: '绿道沿途设置的休息点（资料图）',
      },
      {
        type: 'paragraph',
        text: '管理部门在部分路段增设了休息驿站与补水点，并完善了照明与指示标识，方便市民安全使用。',
      },
      {
        type: 'paragraph',
        text: '有专家建议，骑行时应遵守交通规则、注意避让行人，共同维护良好的出行环境。',
      },
    ],
  },
  {
    id: 'short-variety-shows-companion',
    title: '“电子榨菜”成新宠，陪伴式观看受青睐',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20tablet%20and%20a%20bowl%20of%20noodles%20on%20a%20cozy%20table%20at%20home%2C%20warm%20soft%20light%2C%20minimal%20clean%20aesthetic%2C%20warm%20neutral%20tones%2C%20high%20detail&width=800&height=450&seq=news-buzz-03&orientation=landscape',
    summary:
      '轻松、短小、适合边吃边看的“下饭”内容持续受到欢迎，陪伴式观看成为不少人的日常放松方式。',
    publishedAt: '2026-10-12 10:15',
    author: '吃瓜网热议组',
    categoryId: 'buzz',
    tags: ['电子榨菜', '短综艺', '追剧'],
    views: 158030,
    content: [
      {
        type: 'paragraph',
        text: '在社交平台上，一个词被反复提及——“电子榨菜”。它指的是一类轻松、短小、适合边吃饭边观看的内容。',
      },
      {
        type: 'paragraph',
        text: '与需要高度投入的长剧集不同，这类内容节奏轻快、信息负担低，观众在放松的同时也能获得陪伴感。',
      },
      {
        type: 'image',
        src: 'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20warm%20cozy%20living%20room%20corner%20with%20a%20tv%20glow%20and%20soft%20cushions%2C%20minimal%20clean%20aesthetic%2C%20warm%20neutral%20tones%2C%20high%20detail&width=1000&height=560&seq=news-buzz-03-body&orientation=landscape',
        caption: '许多人习惯在家边吃边看（资料图）',
      },
      {
        type: 'paragraph',
        text: '内容创作者表示，这类作品的难点在于保持轻松的同时不显得敷衍，需要在节奏与选题上花心思。',
      },
      {
        type: 'paragraph',
        text: '平台方面也在尝试推出更多时长适中、题材轻松的内容，满足观众的碎片化观看需求。',
      },
    ],
  },
  {
    id: 'theater-market-heating-up',
    title: '话剧市场持续升温，小剧场演出票提前售罄',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20an%20intimate%20small%20theater%20stage%20with%20warm%20spotlights%20and%20empty%20seats%2C%20minimal%20clean%20aesthetic%2C%20warm%20neutral%20tones%2C%20high%20detail&width=800&height=450&seq=news-ent-04&orientation=landscape',
    summary:
      '越来越多观众走进剧场，小剧场话剧凭借近距离观演与灵活题材受到欢迎，部分场次开票即售罄。',
    publishedAt: '2026-10-11 21:00',
    author: '吃瓜网娱乐组',
    categoryId: 'entertainment',
    tags: ['话剧', '小剧场', '演出'],
    views: 91430,
    content: [
      {
        type: 'paragraph',
        text: '近期话剧演出市场热度不减，尤其是小剧场作品，凭借近距离的观演体验与更为灵活的题材，吸引了不少年轻观众。',
      },
      {
        type: 'paragraph',
        text: '多家剧场表示，部分热门场次在开票后不久便售罄，周末场次尤为紧俏，观众需要提前关注开票信息。',
      },
      {
        type: 'image',
        src: 'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20rehearsal%20script%20and%20pen%20on%20a%20wooden%20table%20under%20warm%20light%2C%20minimal%20clean%20aesthetic%2C%20warm%20neutral%20tones%2C%20high%20detail&width=1000&height=560&seq=news-ent-04-body&orientation=landscape',
        caption: '剧组排练使用的剧本（资料图）',
      },
      {
        type: 'paragraph',
        text: '从业者认为，观众对现场演出的兴趣上升，反映出大家对真实互动体验的重视，也对作品质量提出了更高要求。',
      },
      {
        type: 'paragraph',
        text: '为满足需求，部分剧场计划增加演出场次，并推出面向学生的优惠票，让更多人有机会走进剧场。',
      },
    ],
  },
  {
    id: 'zhou-yanqing-new-film',
    title: '周晏清官宣新片合作，幕后团队阵容引期待',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20film%20clapperboard%20and%20script%20on%20a%20warm%20wooden%20table%20in%20soft%20light%2C%20minimal%20clean%20aesthetic%2C%20warm%20neutral%20tones%2C%20high%20detail&width=800&height=450&seq=news-cele-04&orientation=landscape',
    summary:
      '演员周晏清确认加盟一部新片，片方同步公布编剧与摄影团队，题材与此前作品风格有所不同。',
    publishedAt: '2026-10-11 18:40',
    author: '吃瓜网娱乐组',
    categoryId: 'celebrity',
    tags: ['周晏清', '新片', '电影'],
    views: 165210,
    content: [
      {
        type: 'paragraph',
        text: '演员周晏清确认加盟一部新的电影项目，片方随后公布了编剧、摄影等幕后主创名单，引发不小关注。',
      },
      {
        type: 'paragraph',
        text: '据介绍，新片题材与他此前的作品有所不同，项目目前处于筹备阶段，预计将在完成前期勘景后进入拍摄。',
      },
      {
        type: 'image',
        src: 'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20film%20camera%20on%20a%20tripod%20in%20a%20warm%20lit%20studio%20space%2C%20minimal%20clean%20aesthetic%2C%20warm%20neutral%20tones%2C%20high%20detail&width=1000&height=560&seq=news-cele-04-body&orientation=landscape',
        caption: '项目前期筹备使用的摄影设备（资料图）',
      },
      {
        type: 'paragraph',
        text: '对于题材选择，周晏清在采访中提到，希望尝试不同类型的角色，也希望与更多优秀团队合作。',
      },
      {
        type: 'paragraph',
        text: '目前影片尚未公布上映档期，后续进展有待片方进一步发布。',
      },
    ],
  },
  {
    id: 'night-market-small-business',
    title: '夜间市集人气旺，小微商户找到新舞台',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20lively%20outdoor%20night%20market%20with%20warm%20string%20lights%20and%20small%20stalls%2C%20minimal%20clean%20aesthetic%2C%20soft%20warm%20tones%2C%20high%20detail&width=800&height=450&seq=news-soc-04&orientation=landscape',
    summary:
      '多地举办夜间市集，为手作、小吃与文创摊位提供经营空间，也丰富了市民的夜间休闲选择。',
    publishedAt: '2026-10-11 15:20',
    author: '吃瓜网社会组',
    categoryId: 'society',
    tags: ['夜间经济', '市集', '小微商户'],
    views: 84210,
    content: [
      {
        type: 'paragraph',
        text: '入秋以来，多地推出夜间市集活动，摊位涵盖手作、小吃、文创等品类，成为市民夜间休闲的热门去处。',
      },
      {
        type: 'paragraph',
        text: '对于小微商户而言，市集提供了成本相对可控的经营空间，不少摊主表示，夜市客流让他们获得了更多与顾客直接交流的机会。',
      },
      {
        type: 'image',
        src: 'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20small%20handmade%20craft%20stall%20with%20warm%20lights%20and%20colorful%20goods%2C%20minimal%20clean%20aesthetic%2C%20soft%20warm%20tones%2C%20high%20detail&width=1000&height=560&seq=news-soc-04-body&orientation=landscape',
        caption: '市集上的手作文创摊位（资料图）',
      },
      {
        type: 'paragraph',
        text: '管理方在场地规划、卫生保洁与秩序维护上做了相应安排，希望在活跃夜间经济的同时，兼顾周边居民的休息。',
      },
      {
        type: 'paragraph',
        text: '有商户建议，市集可以考虑增加常态化的宣传与配套服务，帮助摊主积累稳定的顾客群体。',
      },
    ],
  },
  {
    id: 'film-camera-comeback',
    title: '复古胶片相机回潮，年轻人爱上“慢摄影”',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20vintage%20film%20camera%20and%20photo%20prints%20on%20a%20light%20wooden%20desk%20with%20warm%20light%2C%20minimal%20clean%20aesthetic%2C%20warm%20neutral%20tones%2C%20high%20detail&width=800&height=450&seq=news-buzz-04&orientation=landscape',
    summary:
      '复古胶片相机在小圈层里重新流行起来，等待冲洗的过程，让拍照这件事多了几分期待与仪式感。',
    publishedAt: '2026-10-11 09:35',
    author: '吃瓜网热议组',
    categoryId: 'buzz',
    tags: ['胶片相机', '摄影', '复古'],
    views: 128640,
    content: [
      {
        type: 'paragraph',
        text: '在手机拍照已经非常方便的今天，一群年轻人反而重新拿起了胶片相机，用更慢的节奏记录生活。',
      },
      {
        type: 'paragraph',
        text: '拍摄者表示，胶片不能即拍即看，每一次按下快门都更慎重，等待冲洗的过程也让照片多了一层期待。',
      },
      {
        type: 'image',
        src: 'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20row%20of%20developed%20film%20negatives%20hanging%20in%20a%20warm%20lit%20darkroom%2C%20minimal%20clean%20aesthetic%2C%20soft%20warm%20tones%2C%20high%20detail&width=1000&height=560&seq=news-buzz-04-body&orientation=landscape',
        caption: '冲洗中的胶片底片（资料图）',
      },
      {
        type: 'paragraph',
        text: '这股回潮也带动了相关门店的生意，一些影像工作室重新提供冲洗与扫描服务，并开设胶片摄影体验课程。',
      },
      {
        type: 'paragraph',
        text: '摄影爱好者提醒，入门者可以先从常见机型与平价胶卷入手，熟悉操作后再考虑更高阶的器材。',
      },
    ],
  },
];